module.exports = __webpack_public_path__ + "img/second-0.54e1776d.webp";